module.exports = __webpack_public_path__ + "static/scholle3-c4504aac17b35b5f8ac60c0d1d9db2bd.png";